<div class="container-important tw-mt-5" *ngIf="patientRelevantData">
  <!-- nombre, edad y genero del paciente -->
  <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
    <div class="grid-item max-auto tw-relative tw-w-full">
      <div *ngIf="patient" class="tw-flex tw-items-center tw-mb-5 tw-w-4/5 sm:tw-w-full">
        <app-avatar-user [image]="patient.user?.profileImageURL" [name]="patient.user?.name"
                         [lastname]="patient.user?.lastname" [width]="50"></app-avatar-user>
        <div class="tw-ml-4">
          <p class="tw-text-gray-700 tw-text-xl">
            {{ patient.user?.name }} {{ patient.user?.lastname }}
            <img loading="lazy" class="tw-ml-2 tw-w-5"
                 [src]="patient.user.gender === genderEnum.FEMALE ? './../../../assets/images/icons/icons8-female-100.png' : './../../../assets/images/icons/icons8-male-100.png'"
                 alt=""
            />
          </p>
          <p class="text-info">{{ patient.user.birthday | date: 'mediumDate' }}, {{ patient.user.birthday | getAge }}
            años</p>
        </div>
      </div>
      <div class="tw-mb-5">
        <p class="text-subtitle-bold-upper">
          Nivel de salud del paciente
        </p>
        <p class="text-info">Mediante inferencias realizadas por el sistema se determina el nivel de salud actual del
          paciente.</p>
      </div>
      <div class="tw-flex tw-items-start tw-flex-wrap tw-gap-2">
        <div class="tw-flex tw-items-start">
          <div class="tw-mr-3">
            <p class="tw-text-blue-400 tw-text-xs">{{ this.patientRelevantData.score.toFixed(2) }} puntos</p>
            <p class="tw-text-xl"
               [ngClass]="{'tw-text-yellow-500': this.patientRelevantData.totalPercentage < 31, 'tw-text-orange-500': this.patientRelevantData.totalPercentage > 30 && this.patientRelevantData.totalPercentage < 61, 'tw-text-red-500': this.patientRelevantData.totalPercentage > 60}">{{ this.patientRelevantData.totalPercentage.toFixed(2) }}
              %</p>
          </div>
          <app-progress-body [percentage]="this.patientRelevantData.totalPercentage"></app-progress-body>
        </div>
        <div class="tw-flex tw-flex-wrap tw-gap-2">
          <div class="tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-biting-a-carrot-100.png" alt="">
              Alimentación
            </div>

            <div class="tw-flex tw-flex-col">
              <span class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.feeding.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.feeding.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-exercise-100.png" alt="">
              Actividad física
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.physicalActivity.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.physicalActivity.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-opciones-para-ordenar-100.png"
                   alt="">
              Indicadores
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.indicators.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.indicators.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-text-gray-700 tw-font-semibold tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-disease-100.png" alt="">
              Carga genética familiar
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.medicalInheritedFamily.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.medicalInheritedFamily.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
        </div>
      </div>
      <i class="text-info cursor-pointer close-information" nz-icon nzType="close" nzTheme="outline" (click)="$event.stopPropagation();
          viewInformation= false"></i>
    </div>
  </div>

  <div class="grid-container tw-mt-6 tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-4">

    <!-- alimentación -->
    <div class="grid-item">
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-biting-a-carrot-100.png" alt="">
          Alimentación
        </div>
        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.feeding.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>

      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="tw-text-gray-400 tw-text-sm">Plan alimenticio</p>
          <ng-container *ngIf="patientRelevantData.feeding?.mealPlan">
            <div class="text-info tw-flex tw-justify-between">
              {{ patientRelevantData.feeding?.mealPlan?.name }}

              <div class="tw-flex tw-items-center">
                <img class="tw-w-5" loading="lazy" src="./../../../assets/images/icons/icons8-chocolatina-100.png"
                     alt="">
                <p
                  class="tw-text-gray-500 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.netWeight || 0 }}
                  kcal</p>
              </div>
            </div>

            <div class="macros tw-mt-5">
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-sunny-side-up-huevos-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.totalFat_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">Grasas</p>
              </div>
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-pastel-de-nata-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.carbohydrate_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">H.C.</p>
              </div>
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-jamon-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs"> {{ patientRelevantData.feeding?.mealPlan?.macronutrients?.protein_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">Proteínas</p>
              </div>
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-heno-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.dietaryFiber_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">Fibra</p>
              </div>
            </div>
          </ng-container>
          <p class="text-info" *ngIf="!patientRelevantData.feeding?.mealPlan">No se tiene asignado un plan
            alimenticio.</p>

          <nz-divider
            *ngIf="patientRelevantData.feeding?.likedPlan >= 0 || patientRelevantData.feeding?.easyOrDifficultFollowThPlan >= 0 || patientRelevantData.feeding?.feelingOfImprovementInWellBeing >= 0"></nz-divider>

          <div class="tw-mt-4"
               *ngIf="!patientRelevantData.feeding.experienceRecordIsVisible && userLogged.experts && patientRelevantData.feeding?.mealPlan">
            <p class="tw-text-gray-700 tw-font-bold">
              El paciente solo podrá calificar el plan alimenticio una vez concluida una cita
            </p>
          </div>
          <div class="tw-mt-4"
               *ngIf="!patientRelevantData.feeding.experienceRecordIsVisible && userLogged.patients && patientRelevantData.feeding?.mealPlan">
            <p class="tw-text-gray-700 tw-font-bold">
              Solo podrás calificar el plan alimenticio una vez concluida una cita </p>
          </div>

          <div class="tw-mt-4"
               *ngIf="patientRelevantData.feeding.experienceRecordIsVisible && !patientRelevantData.feeding.saved && userLogged.experts && patientRelevantData.feeding?.mealPlan">
            <p class="tw-text-gray-700 tw-font-bold">
              Detectamos que el paciente no ha calificado su plan alimenticio
            </p>
          </div>
          <div class="tw-mt-4"
               *ngIf="patientRelevantData.feeding.experienceRecordIsVisible && !patientRelevantData.feeding.saved && userLogged.patients">
            <p class="tw-text-gray-700 tw-font-bold tw-text-center" *ngIf="patientRelevantData.feeding?.mealPlan">
              Detectamos que no se ha calificado el plan alimenticio, puedes hacerlo dando clic <span class="text-link"
                                                                                                      (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.MY_EXPERIENCE)">aquí</span>
            </p>
          </div>
          <div class="questions tw-mt-5" *ngIf="patientRelevantData.feeding.saved">
            <div class="question tw-mb-3" *ngIf="patientRelevantData.feeding?.likedPlan >= 0">
              <p class="text-info">Del 1 al 10 que valor de satisfacción le darías al menú</p>
              <div class="tw-flex tw-items-center tw-mt-2">
                <img
                  [src]="'./../../../assets/images/icons/' + (patientRelevantData.feeding?.likedPlan > 6 ? 'icons8-like-64.png' : 'icons8-dislike-67.png')"
                  class="tw-w-5 tw-mr-2" alt="">
                <p class="tw-text-gray-500 tw-text-xs">{{ patientRelevantData.feeding?.likedPlan }}</p>
              </div>
            </div>
            <div class="question tw-mb-3" *ngIf="patientRelevantData.feeding?.easyOrDifficultFollowThPlan >= 0">
              <p class="text-info">¿Te fue fácil o difícil llevar el plan?</p>
              <div class="tw-flex tw-items-center tw-mt-2">
                <img
                  [src]="'./../../../assets/images/icons/' + (patientRelevantData.feeding?.easyOrDifficultFollowThPlan > 6 ? 'icons8-like-64.png' : 'icons8-dislike-67.png')"
                  class="tw-w-5 tw-mr-2" alt="">
                <p
                  class="tw-text-gray-500 tw-text-xs">{{ marksEasyOrDifficult[patientRelevantData.feeding?.easyOrDifficultFollowThPlan] }}</p>
              </div>
            </div>
            <div class="question tw-mb-3" *ngIf="patientRelevantData.feeding?.feelingOfImprovementInWellBeing >= 0">
              <p class="text-info">Sensación de mejora en tu bienestar general</p>
              <div class="tw-flex tw-items-center tw-mt-2">
                <img
                  [src]="'./../../../assets/images/icons/' + (patientRelevantData.feeding?.feelingOfImprovementInWellBeing > 6 ? 'icons8-like-64.png' : 'icons8-dislike-67.png')"
                  class="tw-w-5 tw-mr-2" alt="">
                <p class="tw-text-gray-500 tw-text-xs">
                  {{ patientRelevantData.feeding?.feelingOfImprovementInWellBeing === 1 ? 'Ninguna' : patientRelevantData.feeding?.feelingOfImprovementInWellBeing === 10 ? 'Totalmente' : patientRelevantData.feeding?.feelingOfImprovementInWellBeing + ' / 10'}}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantData.feeding.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.feeding.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantData.feeding.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- actividad física -->
    <div class="grid-item">
      <div class="grid-item-layer" *ngIf="!patientRelevantData.physicalActivity.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado datos en la ficha de actividad física. Puede registrarlos dando clic <span
          class="text-link"
          (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.PHYSICAL_ACTIVITY)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantData.physicalActivity.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado datos en la ficha de actividad física
        </p>
      </div>
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-justify-between tw-items-center">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-exercise-100.png" alt="">
          Actividad física
        </div>

        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.physicalActivity.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <ng-container
            *ngIf="physicalActivityLevelEnum.NO_ACTIVITY !== patientRelevantData.physicalActivity?.physicalLevelActivity">
            <p class="tw-text-gray-400 tw-text-sm">Realiza ejercicio desde hace</p>
            <p
              class="text-info tw-mb-5">{{ patientRelevantData.physicalActivity?.exerciseTimeSinceStart | getTranslateEnum:'exerciseTimeSinceStart' }}</p>

            <p class="tw-font-semibold tw-text-gray-700">
              Hace {{ patientRelevantData.physicalActivity.physicalLevelActivity | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info tw-whitespace-normal tw-mb-5"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>{{ levelActivity[patientRelevantData.physicalActivity?.physicalLevelActivity]?.description }}
            </p>

            <p class="tw-text-gray-400 tw-text-sm">Horas de ejercicio a la semana</p>
            <p
              class="text-info tw-mb-5">{{ patientRelevantData.physicalActivity?.exercisePerWeek }} {{ patientRelevantData.physicalActivity?.exercisePerWeek === 1 ? ' hora.' : ' horas' }}</p>
          </ng-container>
          <p class="tw-text-gray-400 tw-text-sm" nz-popover="" [nzPopoverContent]="sedentaryTableTemplate"
             nzTooltipTitle="Niveles de sedentarismo">
            Nivel de sedentarismo
            <i class="tw-ml-1" nz-icon nzType="info-circle" nzTheme="outline"></i>
          </p>
          <ng-container>
            <ng-template #sedentaryTableTemplate>
              <div>
                <p class="text-info tw-mb-2 tw-w-80">
                  Ver películas, redes sociales o videojuegos en celular, tableta, computadora,
                  hablar por teléfono sentado, estar tumbado en el sofá, otros juegos sedentarios.
                </p>
                <ul class="ingredient-list ml-xs">
                  <li class="tw-text-gray-400">Leve: 0 a 2 horas</li>
                  <li class="tw-text-gray-400">Moderado: 2 a 4 horas</li>
                  <li class="tw-text-gray-400">Alto: más de 4 horas</li>
                </ul>
              </div>
              <div>
                <p class="text-info tw-mb-2 tw-w-80">
                  Escuela, oficina, investigación, lectura, estudio, viaje en coche, vuelos, etc.
                </p>
                <ul class="ingredient-list ml-xs">
                  <li class="tw-text-gray-400">Leve: 0 a 2 horas</li>
                  <li class="tw-text-gray-400">Moderado: 2 a 4 horas</li>
                  <li class="tw-text-gray-400">Alto: más de 4 horas</li>
                </ul>
              </div>
            </ng-template>
            <p class="text-info tw-mb-5">En promedio: <span
              class="{{sedentaryLevel[patientRelevantData.physicalActivity?.sedentary.name]}}">{{ patientRelevantData.physicalActivity?.sedentary.name | getTranslateEnum:'sedentaryLevel' }}
              , {{ patientRelevantData.physicalActivity?.sedentary.value + (patientRelevantData.physicalActivity?.sedentary.value === 1 ? ' hora' : ' horas')}} </span>
            </p>
          </ng-container>
          <p class="text-info" *ngIf="!patientRelevantData.physicalActivity?.sedentary">No se han establecido parámetros
            en la ficha de actividad física.</p>
          <p class="tw-text-gray-400 tw-text-sm tw-mt-5 tw-mb-3">Intensidad del ejercicio</p>
          <app-thermometer *ngIf="patientRelevantData.physicalActivity?.exerciseIntensity >= 0"
                           [percentage]="(patientRelevantData.physicalActivity?.exerciseIntensity || 0) * 10"></app-thermometer>
          <p class="text-info" *ngIf="patientRelevantData.physicalActivity?.exerciseIntensity === undefined">No se ha
            determinada la intensidad del ejercicio en la ficha de actividad física.</p>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantData.physicalActivity.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.physicalActivity.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart
              [percentage]="this.patientRelevantData.physicalActivity.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- indicadores -->
    <div class="grid-item">
      <div class="grid-item-layer" *ngIf="!patientRelevantData.indicators.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado los hábitos del paciente. Puede registrarlos dando clic <span
          class="text-link" (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.HABITS)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantData.indicators.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado los hábitos del paciente
        </p>
      </div>
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-opciones-para-ordenar-100.png" alt="">
          Indicadores
        </div>

        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.indicators.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="tw-text-gray-400 tw-text-sm">¿El paciente fuma?</p>
          <p class="text-info" *ngIf="patientRelevantData.indicators?.smokeFrequency">
            Sí, {{(patientRelevantData.indicators?.smokeFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
          <p class="text-info" *ngIf="!patientRelevantData.indicators?.smokeFrequency">No</p>

          <p class="tw-text-gray-400 tw-text-sm tw-mt-3">¿El bebe alcohol?</p>
          <p class="text-info" *ngIf="patientRelevantData.indicators?.drinkAlcohol">
            Sí, {{(patientRelevantData.indicators?.drinkAlcoholFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
          <p class="text-info" *ngIf="!patientRelevantData.indicators?.drinkAlcohol">No</p>

          <p class="tw-text-gray-400 tw-text-sm tw-mt-3">¿El paciente tome café?</p>
          <p class="text-info" *ngIf="patientRelevantData.indicators?.drinkCoffee">
            Sí, {{(patientRelevantData.indicators.drinkCoffeeFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
          <p class="text-info" *ngIf="!patientRelevantData.indicators?.drinkCoffee">No</p>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantData.indicators.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.indicators.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantData.indicators.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- carga genetica familiar -->
    <div class="grid-item">
      <div class="grid-item-layer" *ngIf="!patientRelevantData.medicalInheritedFamily.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado enfermedades heredo-familiares. Puede registrarlas dando clic <span
          class="text-link" (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.FAMILIAL_MEDICAL)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantData.medicalInheritedFamily.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado enfermedades heredo-familiares
        </p>
      </div>
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-disease-100.png" alt="">
          Carga genética
        </div>
        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.medicalInheritedFamily.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="text-info" *ngIf="patientRelevantData.medicalInheritedFamily?.diseaseCategories.length === 0">No se
            han registrado enfermedades.</p>
          <div *ngIf="patientRelevantData.medicalInheritedFamily?.diseaseCategories.length > 0">
            <div *ngFor="let category of patientRelevantData.medicalInheritedFamily.diseaseCategories">
              <p class="tw-text-gray-400 tw-text-sm">{{ category.name }}</p>
              <div *ngFor="let disease of category.diseases">
                <div class="tw-flex tw-items-center tw-ml-2">
                  <p
                    class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                  <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
                </div>
                <span class="tw-text-gray-800 tw-text-xs tw-ml-2"
                      *ngIf="disease.familyMembers | getCountDiseaseParents; let parentCount">Presentada por {{ parentCount }} {{ parentCount === 1 ? 'pariente.' : 'parientes.' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{ this.patientRelevantData.medicalInheritedFamily.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.medicalInheritedFamily.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart
              [percentage]="this.patientRelevantData.medicalInheritedFamily.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- resultados de laboratorios -->
    <div class="grid-item min-h-scroll">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-biochemist-64.png" alt="">
        Resultado de laboratorios
      </p>
      <ng-scrollbar class="my-scrollbar biochemical-scrollbar scroll-section">
        <div class="tw-flex tw-flex-col" *ngIf="patientRelevantData.laboratory?.biochemicals.length > 0">
          <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
               *ngFor="let biochemical of patientRelevantData.laboratory?.biochemicals"
               [nzTooltipTitle]="'Valor de referencia: ' + biochemical.range.min + ' a ' + biochemical.range.max + ' ' + biochemical.measureUnitSymbolEs"
               nzTooltipPlacement="top" nz-tooltip>
            <p class="tw-text-gray-400 tw-text-sm tw-mb-1 tw-flex tw-items-center tw-justify-between">
              {{ biochemical.nameEs }}
              <span class="option-item-warning">
                      {{ biochemical.value < biochemical.range.min ? 'Nivel bajo' : 'Nivel alto' }}
                    </span>
            </p>
            <p class="text-info">{{biochemical.value}} {{ biochemical.measureUnitSymbolEs }}</p>
          </div>
        </div>
        <p class="text-info" *ngIf="patientRelevantData.laboratory?.biochemicals.length === 0">No se han registrado
          resultados de laboratorios.</p>
      </ng-scrollbar>
      <div class="scroll-section tw-block sm:tw-hidden">
        <div class="tw-flex tw-flex-col" *ngIf="patientRelevantData.laboratory?.biochemicals.length > 0">
          <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
               *ngFor="let biochemical of patientRelevantData.laboratory?.biochemicals"
               [nzTooltipTitle]="'Valor de referencia: ' + biochemical.range.min + ' a ' + biochemical.range.max + ' ' + biochemical.measureUnitSymbolEs"
               nzTooltipPlacement="top" nz-tooltip>
            <p class="tw-text-gray-400 tw-text-sm tw-mb-1 tw-flex tw-items-center tw-justify-between">
              {{ biochemical.nameEs }}
              <span class="option-item-warning">
                      {{ biochemical.value < biochemical.range.min ? 'Nivel bajo' : 'Nivel alto' }}
                    </span>
            </p>
            <p class="text-info">{{biochemical.value}} {{ biochemical.measureUnitSymbolEs }}</p>
          </div>
        </div>
        <p class="text-info" *ngIf="patientRelevantData.laboratory?.biochemicals.length === 0">No se han registrado
          resultados de laboratorios.</p>
      </div>
    </div>

    <!-- diagnostico nutricio -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-healthy-100.png" alt="">
        Diagnóstico nutricio
      </p>
      <ng-container *ngIf="patientRelevantData.diagnosis?.cardiovascularRisk">
        <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100">
          <div class="tw-text-gray-400 tw-text-sm tw-flex tw-items-center tw-justify-between">
            Relación IMC / ICC

            <div *ngIf="patientRelevantData.diagnosis.cardiovascularRisk.metadata" class="option-item active" nz-popover=""
                 [nzPopoverContent]="imcTableTemplate" [nzPopoverMouseEnterDelay]="0.25">
              Clasificación
              <i class="tw-ml-1" nz-icon nzType="info-circle" nzTheme="outline"></i>
              <ng-template #imcTableTemplate>
                <div>
                  <app-icc-imc-table-relation-table
                    [metadata]="patientRelevantData.diagnosis.cardiovascularRisk.metadata"
                  ></app-icc-imc-table-relation-table>
                </div>
              </ng-template>
            </div>
          </div>
          <ng-container *ngIf="patientRelevantData.diagnosis.cardiovascularRisk.metadata">
            <p class="tw-text-gray-400 tw-text-sm tw-mt-3">Tipo de cuerpo</p>
            <app-body-type [metadata]="patientRelevantData.diagnosis?.cardiovascularRisk.metadata"></app-body-type>

            <p class="tw-text-gray-400 tw-text-sm tw-mt-3 tw-mb-3">
              Grado {{ patientRelevantData.diagnosis.cardiovascularRisk.metadata.grade }}, Riesgo <span>
                    {{ patientRelevantData.diagnosis.cardiovascularRisk.metadata.risk | getTranslateEnum:'cardiovascularRisk' }}</span>
            </p>
            <app-thermometer [risk]="patientRelevantData.diagnosis.cardiovascularRisk.metadata.risk"></app-thermometer>
          </ng-container>
          <p class="text-info" *ngIf="!patientRelevantData.diagnosis.cardiovascularRisk.metadata">No se han registrado
            la mediciones necesarias para calcular el riesgo cardiovascular.</p>
        </div>
      </ng-container>
    </div>


    <!-- diagnostico medico -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-medical-report-100.png" alt="">
        Diagnóstico médico
      </p>
      <p class="text-info" *ngIf="patientRelevantData.medicalPersonal?.diseaseCategories.length === 0">No se han
        registrado enfermedades.</p>
      <ng-scrollbar class="my-scrollbar scroll-section"
                    *ngIf="patientRelevantData.medicalPersonal?.diseaseCategories.length > 0">
        <div *ngIf="patientRelevantData.medicalPersonal?.diseaseCategories.length > 0">
          <div *ngFor="let category of patientRelevantData.medicalPersonal.diseaseCategories">
            <p class="tw-text-gray-400 tw-text-sm tw-mt-3">{{ category.name }}</p>
            <div *ngFor="let disease of category.diseases">
              <div class="tw-flex tw-items-center tw-ml-2">
                <p
                  class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>

    <!-- medicamentos -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-medicine-64.png" alt="">
        Medicamentos
      </p>
      <p class="tw-text-gray-400 tw-text-sm">Medicamentos que toma el paciente</p>
      <p
        class="text-info tw-break-all">{{patientRelevantData.medicines?.medicines || 'No hay medicamentos registrados.'}}</p>
    </div>

    <!-- preferencias -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-handshake-100.png" alt="">
        Preferencias
      </p>

      <p class="tw-text-gray-400 tw-text-sm">Régimen alimenticio</p>
      <p class="text-info">{{ patientRelevantData.nutritionalHistory?.feedingPreference || 'no establecido' }}</p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Alergias</p>
      <p class="text-info">
        {{ patientRelevantData.nutritionalHistory?.allergies.length > 0 ?
        (patientRelevantData.nutritionalHistory?.allergies | stringifyArray:'text') :
        'no establecido'
        }}
      </p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Le encantan los alimentos</p>
      <p class="text-info">{{ patientRelevantData.nutritionalHistory?.foodLikes || 'no establecido' }}</p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">No le gustan los alimentos</p>
      <p class="text-info">{{ patientRelevantData.nutritionalHistory?.foodDislikes || 'no establecido' }}</p>
    </div>

    <!-- metas del paciente -->
    <div class="grid-item grid-item-goals">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-account-100-2.png" alt="">
        Metas del paciente
      </p>

      <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
           *ngFor="let goal of patientRelevantData.patientGoals">
        <div class="tw-mb-4">
          <p class="text-info tw-mr-3">{{ goal.measurement?.name_es || 'no definido' }}</p>
          <p class="tw-text-red-400 tw-font-semibold tw-text-xs"
             *ngIf="goal.percentage !== -1">{{ goal.percentage.toFixed(2) }} % de progreso</p>
        </div>
        <div class="tw-flex tw-gap-8 tw-flex-wrap">
          <div>
            <p class="tw-text-gray-400 tw-text-sm">Valor inicial</p>
            <p *ngIf="!goal.metadata?.userValues"
               class="text-info"> {{goal.initial}} {{ goal.measureUnit?.symbol_es }}</p>
            <p *ngIf="goal.metadata?.userValues" class="text-info">
              {{goal.metadata.userValues[goal.initial]}}
            </p>
          </div>

          <div>
            <p class="tw-text-gray-400 tw-text-sm">Valor actual</p>
            <p *ngIf="!goal.metadata?.userValues"
               class="text-info">{{goal.actual}} {{ goal.measureUnit?.symbol_es }}</p>
            <p *ngIf="goal.metadata?.userValues" class="text-info">
              {{goal.metadata.userValues[goal.actual]}}</p>
          </div>

          <div>
            <p class="tw-text-gray-400 tw-text-sm">Meta final</p>
            <div class="tw-flex" *ngIf="!goal.metadata?.userValues">
              <p class="tw-text-green-500 tw-font-semibold">{{goal.goalStart}} {{ goal.measureUnit?.symbol_es }} <span
                *ngIf="goal.goalType === patientGoalNumberType.BETWEEN_VALUE"> - {{goal.goalEnd}} {{ goal.measureUnit?.symbol_es }}</span>
              </p>
            </div>
            <div *ngIf="goal.metadata?.userValues">
              <p class="tw-text-green-500 tw-font-semibold">{{ goal.metadata.userValues[goal.goalStart] }}</p>
              <p class="tw-text-green-500 tw-font-semibold tw-ml-1.5"
                 *ngIf="goal.goalType === patientGoalNumberType.BETWEEN_VALUE">
                - {{ goal.metadata.userValues[goal.goalEnd]
                }}</p>
            </div>
          </div>

          <div>
            <p class="tw-text-gray-400 tw-text-sm">Fecha estimada</p>
            <p class="text-info">{{ goal.goalDate | date:'medium' }}</p>
          </div>

          <p class="tw-text-green-500 tw-bg-green-50 tw-rounded tw-w-max tw-p-2" *ngIf="goal.percentage === 100">El
            paciente se encuentra en el valor deseado</p>
        </div>
      </div>

      <p *ngIf="patientRelevantData?.patientGoals.length === 0" class="text-info">No se han registrado metas del
        paciente.</p>
    </div>
  </div>
</div>
<div class="container-important tw-mt-5" *ngIf="patientRelevantData">
  <!-- nombre, edad y genero del paciente -->
  <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
    <div class="grid-item max-auto tw-relative tw-w-full">
      <div *ngIf="patient" class="tw-flex tw-items-center tw-mb-5 tw-w-4/5 sm:tw-w-full">
        <app-avatar-user [image]="patient.user?.profileImageURL" [name]="patient.user?.name"
                         [lastname]="patient.user?.lastname" [width]="50"></app-avatar-user>
        <div class="tw-ml-4">
          <p class="tw-text-gray-700 tw-text-xl">
            {{ patient.user?.name }} {{ patient.user?.lastname }}
            <img loading="lazy" class="tw-ml-2 tw-w-5"
                 [src]="patient.user.gender === genderEnum.FEMALE ? './../../../assets/images/icons/icons8-female-100.png' : './../../../assets/images/icons/icons8-male-100.png'"
                 alt=""
            />
          </p>
          <p class="text-info">{{ patient.user.birthday | date: 'mediumDate' }}, {{ patient.user.birthday | getAge }}
            años</p>
        </div>
      </div>
      <div class="tw-mb-5">
        <p class="text-subtitle-bold-upper">
          Nivel de salud del paciente
        </p>
        <p class="text-info">Mediante inferencias realizadas por el sistema se determina el nivel de salud actual del
          paciente.</p>
      </div>
      <div class="tw-flex tw-items-start tw-flex-wrap tw-gap-2">
        <div class="tw-flex tw-items-start">
          <div class="tw-mr-3">
            <p class="tw-text-blue-400 tw-text-xs">{{ this.patientRelevantData.score.toFixed(2) }} puntos</p>
            <p class="tw-text-xl"
               [ngClass]="{'tw-text-yellow-500': this.patientRelevantData.totalPercentage < 31, 'tw-text-orange-500': this.patientRelevantData.totalPercentage > 30 && this.patientRelevantData.totalPercentage < 61, 'tw-text-red-500': this.patientRelevantData.totalPercentage > 60}">{{ this.patientRelevantData.totalPercentage.toFixed(2) }}
              %</p>
          </div>
          <app-progress-body [percentage]="this.patientRelevantData.totalPercentage"></app-progress-body>
        </div>
        <div class="tw-flex tw-flex-wrap tw-gap-2">
          <div class="tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-biting-a-carrot-100.png" alt="">
              Alimentación
            </div>

            <div class="tw-flex tw-flex-col">
              <span class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.feeding.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.feeding.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-exercise-100.png" alt="">
              Actividad física
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.physicalActivity.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.physicalActivity.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-opciones-para-ordenar-100.png"
                   alt="">
              Indicadores
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.indicators.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.indicators.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-text-gray-700 tw-font-semibold tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-disease-100.png" alt="">
              Carga genética familiar
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.medicalInheritedFamily.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantData.medicalInheritedFamily.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
        </div>
      </div>
      <i class="text-info cursor-pointer close-information" nz-icon nzType="close" nzTheme="outline" (click)="$event.stopPropagation();
          viewInformation= false"></i>
    </div>
  </div>

  <div class="grid-container tw-mt-6 tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-4">

    <!-- alimentación -->
    <div class="grid-item">
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-biting-a-carrot-100.png" alt="">
          Alimentación
        </div>
        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.feeding.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>

      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="tw-text-gray-400 tw-text-sm">Plan alimenticio</p>
          <ng-container *ngIf="patientRelevantData.feeding?.mealPlan">
            <div class="text-info tw-flex tw-justify-between">
              {{ patientRelevantData.feeding?.mealPlan?.name }}

              <div class="tw-flex tw-items-center">
                <img class="tw-w-5" loading="lazy" src="./../../../assets/images/icons/icons8-chocolatina-100.png"
                     alt="">
                <p
                  class="tw-text-gray-500 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.netWeight || 0 }}
                  kcal</p>
              </div>
            </div>

            <div class="macros tw-mt-5">
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-sunny-side-up-huevos-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.totalFat_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">Grasas</p>
              </div>
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-pastel-de-nata-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.carbohydrate_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">H.C.</p>
              </div>
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-jamon-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs"> {{ patientRelevantData.feeding?.mealPlan?.macronutrients?.protein_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">Proteínas</p>
              </div>
              <div class="macro">
                <div class="macro-value">
                  <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-heno-100.png" alt=""> -->
                  <p
                    class="tw-text-gray-800 tw-text-xs">{{ patientRelevantData.feeding?.mealPlan?.macronutrients?.dietaryFiber_g || 0 }}
                    g</p>
                </div>
                <p class="tw-text-gray-500 tw-text-xs">Fibra</p>
              </div>
            </div>
          </ng-container>
          <p class="text-info" *ngIf="!patientRelevantData.feeding?.mealPlan">No se tiene asignado un plan
            alimenticio.</p>

          <nz-divider
            *ngIf="patientRelevantData.feeding?.likedPlan >= 0 || patientRelevantData.feeding?.easyOrDifficultFollowThPlan >= 0 || patientRelevantData.feeding?.feelingOfImprovementInWellBeing >= 0"></nz-divider>

          <div class="tw-mt-4"
               *ngIf="!patientRelevantData.feeding.experienceRecordIsVisible && userLogged.experts && patientRelevantData.feeding?.mealPlan">
            <p class="tw-text-gray-700 tw-font-bold">
              El paciente solo podrá calificar el plan alimenticio una vez concluida una cita
            </p>
          </div>
          <div class="tw-mt-4"
               *ngIf="!patientRelevantData.feeding.experienceRecordIsVisible && userLogged.patients && patientRelevantData.feeding?.mealPlan">
            <p class="tw-text-gray-700 tw-font-bold">
              Solo podrás calificar el plan alimenticio una vez concluida una cita </p>
          </div>

          <div class="tw-mt-4"
               *ngIf="patientRelevantData.feeding.experienceRecordIsVisible && !patientRelevantData.feeding.saved && userLogged.experts && patientRelevantData.feeding?.mealPlan">
            <p class="tw-text-gray-700 tw-font-bold">
              Detectamos que el paciente no ha calificado su plan alimenticio
            </p>
          </div>
          <div class="tw-mt-4"
               *ngIf="patientRelevantData.feeding.experienceRecordIsVisible && !patientRelevantData.feeding.saved && userLogged.patients">
            <p class="tw-text-gray-700 tw-font-bold tw-text-center" *ngIf="patientRelevantData.feeding?.mealPlan">
              Detectamos que no se ha calificado el plan alimenticio, puedes hacerlo dando clic <span class="text-link"
                                                                                                      (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.MY_EXPERIENCE)">aquí</span>
            </p>
          </div>
          <div class="questions tw-mt-5" *ngIf="patientRelevantData.feeding.saved">
            <div class="question tw-mb-3" *ngIf="patientRelevantData.feeding?.likedPlan >= 0">
              <p class="text-info">Del 1 al 10 que valor de satisfacción le darías al menú</p>
              <div class="tw-flex tw-items-center tw-mt-2">
                <img
                  [src]="'./../../../assets/images/icons/' + (patientRelevantData.feeding?.likedPlan > 6 ? 'icons8-like-64.png' : 'icons8-dislike-67.png')"
                  class="tw-w-5 tw-mr-2" alt="">
                <p class="tw-text-gray-500 tw-text-xs">{{ patientRelevantData.feeding?.likedPlan }}</p>
              </div>
            </div>
            <div class="question tw-mb-3" *ngIf="patientRelevantData.feeding?.easyOrDifficultFollowThPlan >= 0">
              <p class="text-info">¿Te fue fácil o difícil llevar el plan?</p>
              <div class="tw-flex tw-items-center tw-mt-2">
                <img
                  [src]="'./../../../assets/images/icons/' + (patientRelevantData.feeding?.easyOrDifficultFollowThPlan > 6 ? 'icons8-like-64.png' : 'icons8-dislike-67.png')"
                  class="tw-w-5 tw-mr-2" alt="">
                <p
                  class="tw-text-gray-500 tw-text-xs">{{ marksEasyOrDifficult[patientRelevantData.feeding?.easyOrDifficultFollowThPlan] }}</p>
              </div>
            </div>
            <div class="question tw-mb-3" *ngIf="patientRelevantData.feeding?.feelingOfImprovementInWellBeing >= 0">
              <p class="text-info">Sensación de mejora en tu bienestar general</p>
              <div class="tw-flex tw-items-center tw-mt-2">
                <img
                  [src]="'./../../../assets/images/icons/' + (patientRelevantData.feeding?.feelingOfImprovementInWellBeing > 6 ? 'icons8-like-64.png' : 'icons8-dislike-67.png')"
                  class="tw-w-5 tw-mr-2" alt="">
                <p class="tw-text-gray-500 tw-text-xs">
                  {{ patientRelevantData.feeding?.feelingOfImprovementInWellBeing === 1 ? 'Ninguna' : patientRelevantData.feeding?.feelingOfImprovementInWellBeing === 10 ? 'Totalmente' : patientRelevantData.feeding?.feelingOfImprovementInWellBeing + ' / 10'}}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantData.feeding.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.feeding.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantData.feeding.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- actividad física -->
    <div class="grid-item">
      <div class="grid-item-layer" *ngIf="!patientRelevantData.physicalActivity.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado datos en la ficha de actividad física. Puede registrarlos dando clic <span
          class="text-link"
          (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.PHYSICAL_ACTIVITY)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantData.physicalActivity.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado datos en la ficha de actividad física
        </p>
      </div>
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-justify-between tw-items-center">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-exercise-100.png" alt="">
          Actividad física
        </div>

        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.physicalActivity.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <ng-container
            *ngIf="physicalActivityLevelEnum.NO_ACTIVITY !== patientRelevantData.physicalActivity?.physicalLevelActivity">
            <p class="tw-text-gray-400 tw-text-sm">Realiza ejercicio desde hace</p>
            <p
              class="text-info tw-mb-5">{{ patientRelevantData.physicalActivity?.exerciseTimeSinceStart | getTranslateEnum:'exerciseTimeSinceStart' }}</p>

            <p class="tw-font-semibold tw-text-gray-700">
              Hace {{ patientRelevantData.physicalActivity.physicalLevelActivity | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info tw-whitespace-normal tw-mb-5"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>{{ levelActivity[patientRelevantData.physicalActivity?.physicalLevelActivity]?.description }}
            </p>

            <p class="tw-text-gray-400 tw-text-sm">Horas de ejercicio a la semana</p>
            <p
              class="text-info tw-mb-5">{{ patientRelevantData.physicalActivity?.exercisePerWeek }} {{ patientRelevantData.physicalActivity?.exercisePerWeek === 1 ? ' hora.' : ' horas' }}</p>
          </ng-container>
          <p class="tw-text-gray-400 tw-text-sm" nz-popover="" [nzPopoverContent]="sedentaryTableTemplate"
             nzTooltipTitle="Niveles de sedentarismo">
            Nivel de sedentarismo
            <i class="tw-ml-1" nz-icon nzType="info-circle" nzTheme="outline"></i>
          </p>
          <ng-container>
            <ng-template #sedentaryTableTemplate>
              <div>
                <p class="text-info tw-mb-2 tw-w-80">
                  Ver películas, redes sociales o videojuegos en celular, tableta, computadora,
                  hablar por teléfono sentado, estar tumbado en el sofá, otros juegos sedentarios.
                </p>
                <ul class="ingredient-list ml-xs">
                  <li class="tw-text-gray-400">Leve: 0 a 2 horas</li>
                  <li class="tw-text-gray-400">Moderado: 2 a 4 horas</li>
                  <li class="tw-text-gray-400">Alto: más de 4 horas</li>
                </ul>
              </div>
              <div>
                <p class="text-info tw-mb-2 tw-w-80">
                  Escuela, oficina, investigación, lectura, estudio, viaje en coche, vuelos, etc.
                </p>
                <ul class="ingredient-list ml-xs">
                  <li class="tw-text-gray-400">Leve: 0 a 2 horas</li>
                  <li class="tw-text-gray-400">Moderado: 2 a 4 horas</li>
                  <li class="tw-text-gray-400">Alto: más de 4 horas</li>
                </ul>
              </div>
            </ng-template>
            <p class="text-info tw-mb-5">En promedio: <span
              class="{{sedentaryLevel[patientRelevantData.physicalActivity?.sedentary.name]}}">{{ patientRelevantData.physicalActivity?.sedentary.name | getTranslateEnum:'sedentaryLevel' }}
              , {{ patientRelevantData.physicalActivity?.sedentary.value + (patientRelevantData.physicalActivity?.sedentary.value === 1 ? ' hora' : ' horas')}} </span>
            </p>
          </ng-container>
          <p class="text-info" *ngIf="!patientRelevantData.physicalActivity?.sedentary">No se han establecido parámetros
            en la ficha de actividad física.</p>
          <p class="tw-text-gray-400 tw-text-sm tw-mt-5 tw-mb-3">Intensidad del ejercicio</p>
          <app-thermometer *ngIf="patientRelevantData.physicalActivity?.exerciseIntensity >= 0"
                           [percentage]="(patientRelevantData.physicalActivity?.exerciseIntensity || 0) * 10"></app-thermometer>
          <p class="text-info" *ngIf="patientRelevantData.physicalActivity?.exerciseIntensity === undefined">No se ha
            determinada la intensidad del ejercicio en la ficha de actividad física.</p>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantData.physicalActivity.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.physicalActivity.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart
              [percentage]="this.patientRelevantData.physicalActivity.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- indicadores -->
    <div class="grid-item">
      <div class="grid-item-layer" *ngIf="!patientRelevantData.indicators.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado los hábitos del paciente. Puede registrarlos dando clic <span
          class="text-link" (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.HABITS)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantData.indicators.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado los hábitos del paciente
        </p>
      </div>
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-opciones-para-ordenar-100.png" alt="">
          Indicadores
        </div>

        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.indicators.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="tw-text-gray-400 tw-text-sm">¿El paciente fuma?</p>
          <p class="text-info" *ngIf="patientRelevantData.indicators?.smokeFrequency">
            Sí, {{(patientRelevantData.indicators?.smokeFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
          <p class="text-info" *ngIf="!patientRelevantData.indicators?.smokeFrequency">No</p>

          <p class="tw-text-gray-400 tw-text-sm tw-mt-3">¿El bebe alcohol?</p>
          <p class="text-info" *ngIf="patientRelevantData.indicators?.drinkAlcohol">
            Sí, {{(patientRelevantData.indicators?.drinkAlcoholFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
          <p class="text-info" *ngIf="!patientRelevantData.indicators?.drinkAlcohol">No</p>

          <p class="tw-text-gray-400 tw-text-sm tw-mt-3">¿El paciente tome café?</p>
          <p class="text-info" *ngIf="patientRelevantData.indicators?.drinkCoffee">
            Sí, {{(patientRelevantData.indicators.drinkCoffeeFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
          <p class="text-info" *ngIf="!patientRelevantData.indicators?.drinkCoffee">No</p>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantData.indicators.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.indicators.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantData.indicators.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- carga genetica familiar -->
    <div class="grid-item">
      <div class="grid-item-layer" *ngIf="!patientRelevantData.medicalInheritedFamily.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado enfermedades heredo-familiares. Puede registrarlas dando clic <span
          class="text-link" (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.FAMILIAL_MEDICAL)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantData.medicalInheritedFamily.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado enfermedades heredo-familiares
        </p>
      </div>
      <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
        <div>
          <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-disease-100.png" alt="">
          Carga genética
        </div>
        <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
              nzTooltipTitle="">
                {{(patientRelevantData.medicalInheritedFamily.updatedAt || currentDate) | date: 'MMM d, y'}}
              </span>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="text-info" *ngIf="patientRelevantData.medicalInheritedFamily?.diseaseCategories.length === 0">No se
            han registrado enfermedades.</p>
          <div *ngIf="patientRelevantData.medicalInheritedFamily?.diseaseCategories.length > 0">
            <div *ngFor="let category of patientRelevantData.medicalInheritedFamily.diseaseCategories">
              <p class="tw-text-gray-400 tw-text-sm">{{ category.name }}</p>
              <div *ngFor="let disease of category.diseases">
                <div class="tw-flex tw-items-center tw-ml-2">
                  <p
                    class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                  <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
                </div>
                <span class="tw-text-gray-800 tw-text-xs tw-ml-2"
                      *ngIf="disease.familyMembers | getCountDiseaseParents; let parentCount">Presentada por {{ parentCount }} {{ parentCount === 1 ? 'pariente.' : 'parientes.' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{ this.patientRelevantData.medicalInheritedFamily.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantData.medicalInheritedFamily.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart
              [percentage]="this.patientRelevantData.medicalInheritedFamily.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>

    <!-- resultados de laboratorios -->
    <div class="grid-item min-h-scroll">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-biochemist-64.png" alt="">
        Resultado de laboratorios
      </p>
      <ng-scrollbar class="my-scrollbar biochemical-scrollbar scroll-section">
        <div class="tw-flex tw-flex-col" *ngIf="patientRelevantData.laboratory?.biochemicals.length > 0">
          <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
               *ngFor="let biochemical of patientRelevantData.laboratory?.biochemicals"
               [nzTooltipTitle]="'Valor de referencia: ' + biochemical.range.min + ' a ' + biochemical.range.max + ' ' + biochemical.measureUnitSymbolEs"
               nzTooltipPlacement="top" nz-tooltip>
            <p class="tw-text-gray-400 tw-text-sm tw-mb-1 tw-flex tw-items-center tw-justify-between">
              {{ biochemical.nameEs }}
              <span class="option-item-warning">
                      {{ biochemical.value < biochemical.range.min ? 'Nivel bajo' : 'Nivel alto' }}
                    </span>
            </p>
            <p class="text-info">{{biochemical.value}} {{ biochemical.measureUnitSymbolEs }}</p>
          </div>
        </div>
        <p class="text-info" *ngIf="patientRelevantData.laboratory?.biochemicals.length === 0">No se han registrado
          resultados de laboratorios.</p>
      </ng-scrollbar>
      <div class="scroll-section tw-block sm:tw-hidden">
        <div class="tw-flex tw-flex-col" *ngIf="patientRelevantData.laboratory?.biochemicals.length > 0">
          <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
               *ngFor="let biochemical of patientRelevantData.laboratory?.biochemicals"
               [nzTooltipTitle]="'Valor de referencia: ' + biochemical.range.min + ' a ' + biochemical.range.max + ' ' + biochemical.measureUnitSymbolEs"
               nzTooltipPlacement="top" nz-tooltip>
            <p class="tw-text-gray-400 tw-text-sm tw-mb-1 tw-flex tw-items-center tw-justify-between">
              {{ biochemical.nameEs }}
              <span class="option-item-warning">
                      {{ biochemical.value < biochemical.range.min ? 'Nivel bajo' : 'Nivel alto' }}
                    </span>
            </p>
            <p class="text-info">{{biochemical.value}} {{ biochemical.measureUnitSymbolEs }}</p>
          </div>
        </div>
        <p class="text-info" *ngIf="patientRelevantData.laboratory?.biochemicals.length === 0">No se han registrado
          resultados de laboratorios.</p>
      </div>
    </div>

    <!-- diagnostico nutricio -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-healthy-100.png" alt="">
        Diagnóstico nutricio
      </p>
      <ng-container *ngIf="patientRelevantData.diagnosis?.cardiovascularRisk">
        <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100">
          <div class="tw-text-gray-400 tw-text-sm tw-flex tw-items-center tw-justify-between">
            Relación IMC / ICC

            <div *ngIf="patientRelevantData.diagnosis.cardiovascularRisk.metadata" class="option-item active" nz-popover=""
                 [nzPopoverContent]="imcTableTemplate" [nzPopoverMouseEnterDelay]="0.25">
              Clasificación
              <i class="tw-ml-1" nz-icon nzType="info-circle" nzTheme="outline"></i>
              <ng-template #imcTableTemplate>
                <div>
                  <app-icc-imc-relation-table
                    [metadata]="patientRelevantData.diagnosis.cardiovascularRisk.metadata"
                  ></app-icc-imc-relation-table>
                </div>
              </ng-template>
            </div>
          </div>
          <ng-container *ngIf="patientRelevantData.diagnosis.cardiovascularRisk.metadata">
            <p class="tw-text-gray-400 tw-text-sm tw-mt-3">Tipo de cuerpo</p>
            <app-body-type [metadata]="patientRelevantData.diagnosis?.cardiovascularRisk.metadata"></app-body-type>

            <p class="tw-text-gray-400 tw-text-sm tw-mt-3 tw-mb-3">
              Grado {{ patientRelevantData.diagnosis.cardiovascularRisk.metadata.grade }}, Riesgo <span>
                    {{ patientRelevantData.diagnosis.cardiovascularRisk.metadata.risk | getTranslateEnum:'cardiovascularRisk' }}</span>
            </p>
            <app-thermometer [risk]="patientRelevantData.diagnosis.cardiovascularRisk.metadata.risk"></app-thermometer>
          </ng-container>
          <p class="text-info" *ngIf="!patientRelevantData.diagnosis.cardiovascularRisk.metadata">No se han registrado
            la mediciones necesarias para calcular el riesgo cardiovascular.</p>
        </div>
      </ng-container>
    </div>


    <!-- diagnostico medico -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-medical-report-100.png" alt="">
        Diagnóstico médico
      </p>
      <p class="text-info" *ngIf="patientRelevantData.medicalPersonal?.diseaseCategories.length === 0">No se han
        registrado enfermedades.</p>
      <ng-scrollbar class="my-scrollbar scroll-section"
                    *ngIf="patientRelevantData.medicalPersonal?.diseaseCategories.length > 0">
        <div *ngIf="patientRelevantData.medicalPersonal?.diseaseCategories.length > 0">
          <div *ngFor="let category of patientRelevantData.medicalPersonal.diseaseCategories">
            <p class="tw-text-gray-400 tw-text-sm tw-mt-3">{{ category.name }}</p>
            <div *ngFor="let disease of category.diseases">
              <div class="tw-flex tw-items-center tw-ml-2">
                <p
                  class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>

    <!-- medicamentos -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-medicine-64.png" alt="">
        Medicamentos
      </p>
      <p class="tw-text-gray-400 tw-text-sm">Medicamentos que toma el paciente</p>
      <p
        class="text-info tw-break-all">{{patientRelevantData.medicines?.medicines || 'No hay medicamentos registrados.'}}</p>
    </div>

    <!-- preferencias -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-handshake-100.png" alt="">
        Preferencias
      </p>

      <p class="tw-text-gray-400 tw-text-sm">Régimen alimenticio</p>
      <p class="text-info">{{ patientRelevantData.nutritionalHistory?.feedingPreference || 'no establecido' }}</p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Alergias</p>
      <p class="text-info">
        {{ patientRelevantData.nutritionalHistory?.allergies.length > 0 ?
        (patientRelevantData.nutritionalHistory?.allergies | stringifyArray:'text') :
        'no establecido'
        }}
      </p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Le encantan los alimentos</p>
      <p class="text-info">{{ patientRelevantData.nutritionalHistory?.foodLikes || 'no establecido' }}</p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">No le gustan los alimentos</p>
      <p class="text-info">{{ patientRelevantData.nutritionalHistory?.foodDislikes || 'no establecido' }}</p>
    </div>

    <!-- metas del paciente -->
    <div class="grid-item grid-item-goals">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-account-100-2.png" alt="">
        Metas del paciente
      </p>

      <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
           *ngFor="let goal of patientRelevantData.patientGoals">
        <div class="tw-mb-4">
          <p class="text-info tw-mr-3">{{ goal.measurement?.name_es || 'no definido' }}</p>
          <p class="tw-text-red-400 tw-font-semibold tw-text-xs"
             *ngIf="goal.percentage !== -1">{{ goal.percentage.toFixed(2) }} % de progreso</p>
        </div>
        <div class="tw-flex tw-gap-8 tw-flex-wrap">
          <div>
            <p class="tw-text-gray-400 tw-text-sm">Valor inicial</p>
            <p *ngIf="!goal.metadata?.userValues"
               class="text-info"> {{goal.initial}} {{ goal.measureUnit?.symbol_es }}</p>
            <p *ngIf="goal.metadata?.userValues" class="text-info">
              {{goal.metadata.userValues[goal.initial]}}
            </p>
          </div>

          <div>
            <p class="tw-text-gray-400 tw-text-sm">Valor actual</p>
            <p *ngIf="!goal.metadata?.userValues"
               class="text-info">{{goal.actual}} {{ goal.measureUnit?.symbol_es }}</p>
            <p *ngIf="goal.metadata?.userValues" class="text-info">
              {{goal.metadata.userValues[goal.actual]}}</p>
          </div>

          <div>
            <p class="tw-text-gray-400 tw-text-sm">Meta final</p>
            <div class="tw-flex" *ngIf="!goal.metadata?.userValues">
              <p class="tw-text-green-500 tw-font-semibold">{{goal.goalStart}} {{ goal.measureUnit?.symbol_es }} <span
                *ngIf="goal.goalType === patientGoalNumberType.BETWEEN_VALUE"> - {{goal.goalEnd}} {{ goal.measureUnit?.symbol_es }}</span>
              </p>
            </div>
            <div *ngIf="goal.metadata?.userValues">
              <p class="tw-text-green-500 tw-font-semibold">{{ goal.metadata.userValues[goal.goalStart] }}</p>
              <p class="tw-text-green-500 tw-font-semibold tw-ml-1.5"
                 *ngIf="goal.goalType === patientGoalNumberType.BETWEEN_VALUE">
                - {{ goal.metadata.userValues[goal.goalEnd]
                }}</p>
            </div>
          </div>

          <div>
            <p class="tw-text-gray-400 tw-text-sm">Fecha estimada</p>
            <p class="text-info">{{ goal.goalDate | date:'medium' }}</p>
          </div>

          <p class="tw-text-green-500 tw-bg-green-50 tw-rounded tw-w-max tw-p-2" *ngIf="goal.percentage === 100">El
            paciente se encuentra en el valor deseado</p>
        </div>
      </div>

      <p *ngIf="patientRelevantData?.patientGoals.length === 0" class="text-info">No se han registrado metas del
        paciente.</p>
    </div>
  </div>
</div>
